import { ActionType, ErrorCode } from "../constants";
const initialState = {
  ytScriptLoaded: false,
};
export default (state = initialState, action) => {
  try {
    switch (action.type) {
      case ActionType.loadedYtScript:
        return {
          ...state,
          ytScriptLoaded: true,
        };
      default:
        return state;
    }
  } catch (e) {
    console.log("vidReducer error:", e);
  }
};
